/**
 * 
 * @param {number} t 
 */
export function formatTime(t) {
    return t.toString(10).padStart(2, "0");
}

export function createFormData(data) {
    const formdata = new FormData();
    for (let key in data) {
        formdata.append(key, data[key]);
    }
    return formdata;
}

/**
 * 
 * @param {string} timeString 
 */
export function safeParse(timeString) {
    return Date.parse(timeString.replace(/-/g, "/").replace(/\./g, "/"));
}